/**
 * Project-level permission helper.
 *
 * Rule: when a user has an explicit project membership, that role is
 * authoritative and overrides their system role. The system role is only
 * consulted as a fallback when the user has no project membership at all.
 *
 *   super_admin  → always allowed (unrestricted)
 *   viewer       → always denied
 *   everyone else → project role wins if member; system role as fallback
 *
 * @param {object}   user                 Redux auth user object
 * @param {Array}    members              Project members array ({ user: { id }, role })
 * @param {object}   opts
 * @param {string[]} opts.projectRoles    Project roles that grant this permission
 * @param {string[]} opts.systemFallbackRoles  System roles that grant it when not a member
 */
export function projectPermission(user, members, { projectRoles, systemFallbackRoles }) {
  if (!user || user.role === 'viewer') return false;
  if (user.role === 'super_admin') return true;

  const membership = members?.find(m => m.user?.id === user.id);

  if (membership) {
    // Explicit project membership is authoritative
    return projectRoles.includes(membership.role);
  }

  // No project membership — fall back to system role
  return systemFallbackRoles.includes(user.role);
}
